/**
 * htmltable
 */
export interface WidgetOverview {
    /**
     * createOverview
     */
    createOverview(): Promise<void>;
}
